import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { User, LogOut, Menu, X, Store, BellRing } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { usePedidoStatus } from "@/components/realtime/usePedidoStatus";
import { useDingOnPedido } from "@/hooks/useDingOnPedido";

const Header = ({
  activeTab,
  setActiveTab,
  sidebarOpen,
  setSidebarOpen,
  setOrderFilterStatus,
}) => {
  const { user, logout } = useAuth();
  const { pedido } = usePedidoStatus();
  const [soundEnabled, setSoundEnabled] = useState(true);
  const { retryPlay } = useDingOnPedido(pedido, "./assets/sounds/cash.mp3", {
    autoRetry: true,
    retryMs: 10000,
    maxRetries: 12,
    playOnIncrease: false,
  });

  useEffect(() => {
    retryPlay(pedido > 0 && soundEnabled);
  }, [pedido]);

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-3 md:px-4 py-2 md:py-3 flex items-center justify-between sticky top-0 z-30">
      <div className="flex items-center space-x-2 md:space-x-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="lg:hidden p-2"
        >
          {sidebarOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </Button>
        <div className="flex items-center space-x-2 md:space-x-3">
          <div
            className="w-7 h-7 md:w-8 md:h-8 rounded-lg flex items-center justify-center"
            style={{ background: "#c9332C" }}
          >
            <Store className="h-3 w-3 md:h-4 md:w-4 text-white" />
          </div>
          <div className="hidden sm:block">
            <h1 className="font-bold text-base md:text-xl text-gray-900">
              Delivery Bonfim
            </h1>
            <p className="text-xs text-gray-500 hidden md:block">
              Gestor de cardápio/Delivery
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center space-x-2 md:space-x-3">
        {pedido > 0 && (
          <button
            onClick={() => {
              if (setOrderFilterStatus) {
                setOrderFilterStatus("Aguardando");
              }
              setActiveTab("orders");
              setSidebarOpen(false);
            }}
            className="relative bg-red-700 hover:bg-red-800 text-white p-2 md:p-3 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <BellRing className="w-4 h-4 md:w-6 md:h-6" />
            <span className="absolute -top-1 -right-1 md:-top-2 md:-right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 md:h-6 md:w-6 flex items-center justify-center font-bold">
              {pedido}
            </span>
          </button>
        )}

        <div className="hidden md:flex items-center space-x-2 text-sm">
          <User className="h-4 w-4 text-gray-500" />
          <span className="text-gray-700 font-medium truncate max-w-[150px]">
            {user?.email || user?.username}
          </span>
          <button
            className="inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80"
            style={{ background: "#fee2e2", color: "#c9332C" }}
            onClick={() => setSoundEnabled(true)}
          >
            {soundEnabled ? "Aberta" : "Fechada"}
          </button>
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={logout}
          className="text-red-600 hover:text-red-700 hover:bg-red-50 p-2"
          title="Sair"
        >
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
};

export default Header;
